const RETURN_TO_KEY = 'returnTo';

// Guarda a dónde quería ir el usuario antes de mandarlo al login. Usamos
// sessionStorage porque el OAuth de Twitch/YouTube recarga la página entera
// (se pierde el state de React Router, pero el sessionStorage de la pestaña no).
export function setReturnTo(path) {
  // Solo rutas internas: '/algo'. Descartamos '//host' y '/\host' para no
  // convertir esto en un redirect abierto.
  if (typeof path !== 'string' || path[0] !== '/' || path[1] === '/' || path[1] === '\\') {
    return;
  }
  if (path === '/myAccount') {
    return;
  }
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch (e) { }
}

// Devuelve el destino guardado y lo borra, para que solo se use una vez.
export function consumeReturnTo() {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return path || null;
  } catch (e) {
    return null;
  }
}

export function handleSessionExpired() {
  sessionStorage.setItem('sessionExpired', '1');
  setReturnTo(window.location.pathname + window.location.search);
  window.location.href = '/myAccount';
}

export function checkAuthError(data) {
  if (data && data.error === 'not_authenticated') {
    handleSessionExpired();
    return true;
  }
  return false;
}
